import React, { useContext } from 'react';

import { CompanyContext } from '../../../../../../context/company/companyContext';
import { formatDateForDisplay } from '../../../../../../utils/datetime/datetime';

interface IFormattedDateProps {
  dateString: string;
  separator?: '/' | '-';
}

const FormattedDate: React.FC<IFormattedDateProps> = ({ dateString, separator }) => {
  const { isUSA } = useContext(CompanyContext);
  return <div>{formatDateForDisplay(dateString, isUSA ?? false, separator)}</div>;
};

export default FormattedDate;
